import { ConfigArrayValidation, ConfigValidationField } from '../../types'

export const isArrayValidation = (
  node: ConfigValidationField
): node is ConfigArrayValidation => 'items' in node
